"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateFinancialYearSchema = exports.createFinancialYearSchema = void 0;
const zod_1 = require("zod");
exports.createFinancialYearSchema = zod_1.z
    .object({
    label: zod_1.z.string().min(1).max(20),
    startDate: zod_1.z.coerce.date(),
    endDate: zod_1.z.coerce.date(),
})
    .refine((data) => data.endDate > data.startDate, {
    message: 'endDate must be after startDate',
    path: ['endDate'],
});
exports.updateFinancialYearSchema = zod_1.z.object({
    label: zod_1.z.string().min(1).max(20).optional(),
});
//# sourceMappingURL=financial-year.schema.js.map